import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=6c14074f&"
import script from "./FilesView.vue?vue&type=script&lang=js&"
export * from "./FilesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports